import { Component, OnInit ,ViewChild} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { ApiHttpService } from 'src/app/_services/api-http.service';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/_services/alert.service'; 
import { environment } from 'src/environments/environment'; 
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';

import { ConfigurableNavigationMode, WizardComponent as BaseWizardComponent } from 'angular-archwizard';

@Component({
  selector: 'app-grievance-edit',
  templateUrl: './grievance-edit.component.html',
  styleUrls: ['./grievance-edit.component.scss']
})
export class GrievanceEditComponent implements OnInit {
  arr: any[];
  GISnumber:any;
  stepIndex:any;
  navigationMode: any;
  goToNextStep:boolean = false;
  merchantdis:boolean=true
  backgrid:boolean=true
  showError:boolean=false

  currentDate:any=new Date();
  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete"
  ];


  @ViewChild('acc') private acc: NgbAccordion;
  private gridApi!: GridApi;
  // public rowData: any[];
  public rowData: any[] = [
    // Add more rows here as needed...
  ];

  public interat: any[] = [
    // Add more rows here as needed...
  ];

  
  

  public deleterowData: any[] = [
    // Add more rows here as needed...
  ];
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: false,
    resizable: true
  };
  public columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'status', tooltipField: 'sp_id', headerName: 'Status'},
    { field: 'createdDate', tooltipField: 'sp_id', headerName: 'Create Date'},
    { field: "createdBy", tooltipField: 'sp_id', headerName: 'Create By' },
    { field: "updatedAt", tooltipField: 'sp_id', headerName: 'Updated Date' },
    { field: 'updatedBy', tooltipField: 'sp_id', headerName: 'updated By'},
  ];
  myDate = new Date();
  merchantStatusdata: any;
  pageSize: number = 10;
  private filterObj: any = {};
  SingleRow: any;
  currentPage: number = 0;
  collectionSize: number = 0;
  amount:any;
  merchantName:any;
  totalAmount:any;
  txnDate:any;
  mopType:any;
  customerName:any;
  customerPhone:any;
  payId:any;
  paymentMethod:any;
  grsId:any;
  pgrefNum:any;
  orderId:any;
  usertype:any;
  GrsDescription:any
  
  

  @ViewChild('wizardForm') wizardForm: BaseWizardComponent;

  constructor(private activatedRoute: ActivatedRoute,private apiHttpService: ApiHttpService,) {
    // subscribe to router event
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      console.log(params);

 this.GISnumber=params.data;

    });}
 
    ngOnInit(): void {
      this.usertype="Sub Admin";
      this.merchantdis=true;
      this.backgrid=true

      this.navigationMode = new ConfigurableNavigationMode("deny", "deny")

      this.apiHttpService
      .get(
        `https://uat.pay10.com/crmws/GRS/findGRSHistoryById/${this.GISnumber}`
        )
      .subscribe((data) => {
       debugger

       this.interat=data.grs
       this.amount=this.interat[0].amount
       this.totalAmount=this.interat[0].totalAmount

       this.merchantName=this.interat[0].merchantName
       this.txnDate=this.interat[0].txnDate
       this.mopType=this.interat[0].mopType
       this.customerName=this.interat[0].customerName
       this.payId=this.interat[0].payId
       this.paymentMethod=this.interat[0].paymentMethod
       this.pgrefNum=this.interat[0].pgrefNum
       this.grsId=this.interat[0].grsId
       this.orderId=this.interat[0].orderId
       this.GrsDescription=this.interat[0].grsDesc
let uiFlag=this.interat[0].status
let count=0;
if(uiFlag=="NEW"){
  count=1

}else if(uiFlag=="In PROGRESS"){
  count=2


}else if(uiFlag=="CLOSED"){
  count=3


}else{

  count=2

}


for(let i=0;i<count;i++){
  this.getback1()

}        

          

  

      
    
    });


    this.apiHttpService
      .get(
        // `https://uat.pay10.com/crmws/GRS/findGRSHistoryById/${this.GISnumber}`
        `https://chat.pay10.com/api/chat/${this.GISnumber}/history`
        )
      .subscribe((data) => {
        debugger
       if(data.length>0){
        this.showError=false;

       }else{
        this.showError=true;
       }
debugger
this.stepIndex=   (data?.data|| Array.isArray(data) ? data : []).map((d: any) => {
        if(d.chatType=='Document'){
          this.showMessageDocument(d.sender + ": "+ d.content ,d.fileUrl ,d.senderType,d.timestamp);
        }else{
          this.showMessage(d.sender
              + ": "
              + d.content,d.senderType,d.timestamp);
          
        }
      

 })
    
    });
    
    

    }



    onSearchBtnClick(){
      this.merchantdis=false;
      this.backgrid=false

    }

    getbackgrid(){
      this.merchantdis=true;
      this.backgrid=true
    }


  getback(){
   // window.open('https://globaldev.pay10.com/#/grievanceReport');

    window.open("/#/grievanceReport");
}

onGridReady(datra:any){
  
    return this.apiHttpService
    .get(
      `https://uat.pay10.com/crmws/GRS/findGRSHistoryById/${this.GISnumber}`
      )
    .subscribe((data) => {
      this.collectionSize = data.grs.length        ;
      this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
         return {
          ...d,
        }
      })
    });
}

    getback1(){
  setTimeout(()=>{                           // <<<---using ()=> syntax
        this.wizardForm.goToNextStep();
      
      }, 1000);
      }

      onPageSizeChanges($event: Event) {
      }
      tableSelectedColumn: ColDef[] = [...this.columnDefs];

      onPaginationChange(param: PaginationChangedEvent | any) {
       
            debugger
            this.apiHttpService
            .get(
              `https://uat.pay10.com/crmws/GRS/findGRSHistoryById/${this.GISnumber}`
              )
            .subscribe((data) => {
              this.collectionSize = data.grs.length ;
              this.pageSize
           let currentpagedata=   this.currentPage-1;
              this.deleterowData=this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
                return {
                 ...d,
               }
             })
             this.deleterowData.splice(0,currentpagedata*this.pageSize)
              this.rowData =  this.deleterowData
            });
        this.gridApi.paginationGoToPage(param - 1)
      }
      fun(id:any){
        document?.getElementById(id)?.classList.add("hey")
      }
      funover(id:any){
        document?.getElementById(id)?.classList.remove("hey")
      }
    
      onFilterModified(param: FilterModifiedEvent | any) {
        debugger
        const temp = param?.filterInstance;
        this.filterObj[param?.column?.colId] = temp;
      }

       formatDateTime(dateTimeString:any) {
        const date = new Date(dateTimeString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ampm = parseInt(hours) >= 12 ? 'PM' : 'AM';
        const formattedDateTime = year+'-'+month+'-'+day+' '+hours+':'+minutes+':'+seconds+' '+ampm;
        return formattedDateTime;
      }


       showMessageDocument	(message:any,fileurl:any,sender:any,timeStampB:any) {
        debugger
        const timestamp = this.formatDateTime(timeStampB);
        const chatBox = document.getElementById('chatBox');
        const userInput = document.getElementById('userInput');
        const sendButton = document.getElementById('sendButton');
        // Create a div for the timestamp
        const timestampElement = document.createElement('div');
        timestampElement.textContent = timestamp;
        const messageContainer = document.createElement('div');
        messageContainer.textContent = message;
        messageContainer.classList.add('message');
        let img = new Image(20, 20);
        img.src ='../assets/image/cloud-arrow-down-solid.svg';
        img.addEventListener("click", function() {

          const apiUrl = 'https://chat.pay10.com/api/document/download/';

          // Send the AJAX request
          $.ajax({
            url: apiUrl,
            method: 'POST', // or 'GET' depending on your API
            contentType: 'application/json',
            data: JSON.stringify({ filePath: fileurl }),
            xhrFields: {
            responseType: 'blob',
            },
            success: function (blob) {
            // Create a temporary link element to trigger the download
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileurl.substring(fileurl.lastIndexOf('/') + 1);
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(url);
            },
            error: function (error) {
            console.error('Error while downloading:', error);
            },
          });
      
          })
        img.classList.add("my-class");
        messageContainer.appendChild(img);
        messageContainer.classList.add("my-class1");
        debugger
        if (sender === this.usertype) {
          timestampElement.classList.add('message-timestamp-end');
          messageContainer.classList.add('user-message'); 
      
          
          messageContainer.appendChild(timestampElement);
        }else if (sender === 'BOT')  {
          messageContainer.classList.add('bot-message');
          } 
        else  {
          timestampElement.classList.add('message-timestamp-start');
          messageContainer.classList.add('admin-message');
          messageContainer.appendChild(timestampElement); 
        }
        if(chatBox){
        chatBox.appendChild(messageContainer);
        chatBox.scrollTop = chatBox.scrollHeight;
        }
    }


     downloadfile(filePath:any) {
      // Define the API endpoint URL
      const apiUrl = 'https://chat.pay10.com/api/document/download/';

      // Send the AJAX request
      $.ajax({
        url: apiUrl,
        method: 'POST', // or 'GET' depending on your API
        contentType: 'application/json',
        data: JSON.stringify({ filePath: filePath }),
        xhrFields: {
        responseType: 'blob',
        },
        success: function (blob) {
        // Create a temporary link element to trigger the download
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filePath.substring(filePath.lastIndexOf('/') + 1);
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        },
        error: function (error) {
        console.error('Error while downloading:', error);
        },
      });
      }

    
   

       showMessage(message:any,sender:any,timeStampB:any) {
        const chatBox = document.getElementById('chatBox');
        const userInput = document.getElementById('userInput');
        const sendButton = document.getElementById('sendButton');
        const timestamp = this.formatDateTime(timeStampB);// Get the current timestamp
  
        // Create a div for the timestamp
        const timestampElement = document.createElement('div');
        timestampElement.textContent = timestamp;
        
        const messageContainer = document.createElement('div');
        messageContainer.textContent = message;
        messageContainer.classList.add('message');
        
        if (sender === this.usertype) {
          timestampElement.classList.add('message-timestamp-end');
          messageContainer.classList.add('user-message'); 
          messageContainer.appendChild(timestampElement);
        }else if (sender === 'BOT')  {
          messageContainer.classList.add('bot-message');
          } 
        else  {
          timestampElement.classList.add('message-timestamp-start');
          messageContainer.classList.add('admin-message');
          messageContainer.appendChild(timestampElement);
          
        }
       
        if(chatBox){
        chatBox.appendChild(messageContainer);
        
        chatBox.scrollTop = chatBox.scrollHeight;
        }
      }

}
